// Leitet aus dem Firmennamen einen sauberen Markennamen ab (Rechtsform-Suffix entfernt).
// Beispiel: "StrongFit GmbH" -> "StrongFit", "Müller Fitness AG" -> "Müller Fitness".
export const toBrandName = (raw) => {
  const base = (raw || '').trim();
  if (!base) return 'Studio';
  const stripped = base
    .replace(/\s+(GmbH\s*&\s*Co\.?\s*KG|GmbH|AG|KG|OHG|e\.?K\.?|S[aà]rl|SARL|SA|Ltd\.?|Inc\.?|LLC)\.?$/i, '')
    .trim();
  return stripped || base;
};
